import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import theme from "../theme/theme";
import Layout from "../components/Layout";
import { Toaster } from "react-hot-toast";
import { ModalContextProvider } from "./ModalProvider";
import GoldPriceProvider from "./GoldPriceProvider";
import { PermissionsProvider } from "./PermissionsProvider";
import { AuthProvider } from "./AuthProvider";
import { CatalogProvider } from "./CatalogProvider";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/pt-br';
import { PendingQuotesProvider } from "./PendingQuotesProvider";
import { NotificationsProvider } from "./NotificationsProvider";
import AppTutorial from "../components/AppTutorial";

export default function ComponentProvider({ children }) {

    const queryClient = new QueryClient();

    return (
        <BrowserRouter>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
                <QueryClientProvider client={queryClient}>
                    <ThemeProvider theme={theme}>
                        <ModalContextProvider>
                            <AuthProvider>
                                <PermissionsProvider>
                                    <CatalogProvider>
                                        <PendingQuotesProvider>
                                            <NotificationsProvider>
                                                <GoldPriceProvider>
                                                    <Layout>
                                                        {children}
                                                    </Layout>
                                                    <AppTutorial />
                                                </GoldPriceProvider>
                                                <Toaster position="top-center" reverseOrder={false} />
                                            </NotificationsProvider>
                                        </PendingQuotesProvider>
                                    </CatalogProvider>
                                </PermissionsProvider>
                            </AuthProvider>
                        </ModalContextProvider>
                    </ThemeProvider>
                </QueryClientProvider>
            </LocalizationProvider>
        </BrowserRouter>
    );
};